import { combineReducers } from 'redux'
import {
  GET_CARS_FAIL, GET_CARS_SUCCESS,
  CARS_IS_LOADING,
  GET_CARDETAILS_SUCCESS, SAVE_SELECTEDCAR,
  SAVE_SELECTEDDIAMETERS,
  UPDATE_UI_SUCCESS, ACTN_REFRESH
} from "./action-types.js"; 
//import { Object } from "core-js";

const initialState = {
  makerModelYear: [],
  carDetails: [],
  isLoading: false,
  error: "",
  ui: { noTireSizeForCar: false },
  selectedCarProperties: ["chassis", "chassisIsSelected", "ktype", "maker", "model", "type", "typeIsSelected", "tyreFit", "year"]
};

const carsReducer = (state = initialState, action) => {
  if ((!state.selectedCarProperties) || (state.selectedCarProperties.filter(x => initialState.selectedCarProperties.indexOf(x) === -1))) {
    state.selectedCarProperties = initialState.selectedCarProperties;
  }
  if (!state.ui) {
    state.ui = initialState.ui;
  }

  switch (action.type) {

    case UPDATE_UI_SUCCESS:
      return { ...state, ui: { ...state.ui, ...action.data } };
    case GET_CARS_SUCCESS:
      return { ...state, ...(action.cars) };
    case CARS_IS_LOADING:
      return { ...state, isLoading: action.isLoading };

    case GET_CARDETAILS_SUCCESS:
      return { ...state, carDetails: action.carDetails };
    case SAVE_SELECTEDCAR:
      return { ...state, selectedCar: action.selectedCar };
    case SAVE_SELECTEDDIAMETERS:
      return { ...state, selectedCarDiameters: { ...(state.selectedCarDiameters), selectedDiameters: action.selectedDiameters } };

    case ACTN_REFRESH:
      //if (action.data.updateValue) {
      //  state = { ...state };

      //  var value = state;
      //  var newValue = state;

      //  var lastKey = null;

      //  action.data.updateValue.keys.forEach((v, i, a) => {
      //    lastKey = v;

      //    if (i < (a.length - 1)) {
      //      newValue = value[lastKey];

      //      if (typeof(newValue) != "object") {
      //        newValue = {};

      //        value[lastKey] = newValue;
      //      }

      //      value = newValue;
      //    }
      //  });

      //  newValue[lastKey] = action.data.updateValue.value;
      //}


      if (action.data.cars) {
        state = {
          ...state, carDetails: action.data.cars
        };
      }
      if (action.data.promotedWheels) {
        state = {
          ...state, selectedCarWheels: action.data.promotedWheels
        };
      }
      if (action.data.diameters) {
        state = {
          ...state, selectedCarDiameters: action.data.diameters 
        };
      }
      if (action.data.links) {
        state = {
          ...state, selectedCarLinks: action.data.links
        };

        window.initLinksFilters = null;
      }
      if (action.data.carLabels) {
        state = {
          ...state, selectedCarLabels: action.data.carLabels
        };

        window.initCarLabels = null;
      }
      if (action.data.post) {
        state = {
          ...state, post: action.data.post
        };
      }

      return state;
      // ["maker", "model", "year", "ktype"].forEach(p => state.selectedCar = { ...state.selectedCar, [p]: action.data[p] });
      // return state;

    default:
      return state;
  }
};

export default carsReducer;